import { useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Badge, Button, Container, Heading, HStack, Text, useDisclosure } from '@chakra-ui/react';
import { formatRfiStatus, getRfiStatusBadgeColor } from 'modules/kyc/utils/utils';
import KybComplianceDetails from 'modules/merchantinfo/components/KybComplianceDetails';
import UpdateKybStatusModal from 'modules/merchantinfo/components/UpdateKybStatusModal';
import { snakeToTitleCase } from 'utils/utils';

export default function KybDetails() {
  const history = useHistory();
  const location = useLocation();
  const { kybId: kybIdParam } = useParams();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const kybId = location.state?.kybId || kybIdParam;
  const entityId = location.state?.entityId;
  const entityName = location.state?.entityName;

  const [kybStatus, setKybStatus] = useState(location.state?.kybStatus);

  return (
    <Container maxW='100%' py={8}>
      <HStack mb={3} spacing={6} align='center'>
        <Button colorScheme='gray' onClick={() => history.goBack()} size='md'>
          Back
        </Button>
        <Heading as='h1' size='lg' flex='1' textAlign='center'>
          {entityName ? `${entityName} - KYB Details` : 'KYB Details'}
        </Heading>
        {kybStatus && (
          <Badge colorScheme={getRfiStatusBadgeColor(kybStatus)} rounded='full' px={3} py={1}>
            {formatRfiStatus(kybStatus) === 'N/A' ? snakeToTitleCase(kybStatus) : formatRfiStatus(kybStatus)}
          </Badge>
        )}
        {entityId && (
          <Button colorScheme='blue' size='md' onClick={onOpen}>
            Update KYB Status
          </Button>
        )}
      </HStack>

      {kybId ? (
        <KybComplianceDetails kybId={kybId} onStatusLoaded={({ status }) => setKybStatus((prev) => prev || status)} />
      ) : (
        <Text color='gray.500'>No KYB selected.</Text>
      )}

      {entityId && (
        <UpdateKybStatusModal
          isOpen={isOpen}
          onClose={onClose}
          entityId={entityId}
          currentStatus={kybStatus}
          onStatusUpdated={(status) => setKybStatus(status)}
        />
      )}
    </Container>
  );
}
